import {css} from 'lit';

import {defaultStyles} from '../../../components/spinner.js';

export const styles = defaultStyles.extends({
  statics: css``,
  colorGen: () => '',
  sizeGen: () => '',
});

export default {styles};
